'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { AgencyConnecture } from '../Agency/AgencyConnecture';
import { GlobConnectureOrg } from '../Glob/GlobConnectureOrg';
//import { UserIntegrationProvider } from '../User/UserIntegrationProvider';

export class UserConnecture extends Entity {
  protected id;
  protected userId;
  protected username;
  protected agencyConnecture;
  protected globConnectureOrg;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.username = data.username;

    if (data.agencyConnecture) {
      const connecture = new AgencyConnecture();

      connecture.hydrate(data.agencyConnecture);

      this.agencyConnecture = connecture;
    }

    if (data.globConnectureOrg) {
      const globConneecture = new GlobConnectureOrg();

      globConneecture.hydrate(data.globConnectureOrg);

      this.globConnectureOrg = globConneecture;
    }
  }

  public getId() {
    return this.id;
  }

  public getUsername() {
    return this.username;
  }

  public getAgencyConnecture() {
    return this.agencyConnecture;
  }

  public getGlobConnectureOrg() {
    return this.globConnectureOrg;
  }
}
